import { TEXT_PRESET_KEY } from '@optimus-web/local-tokens';
import { TypographyProps } from '../../types';
import { Typography } from '../../Typography';

export const ModerateHighlight = (props: Omit<TypographyProps, 'preset'>) => (
    <Typography {...props} preset={TEXT_PRESET_KEY['500m']} as="strong" />
);
